<template>
  <info-page
    v-if="firstAccess"
    title="Envie remessas internacionais"
  >
    <template #image>
      <bg-illustration name="girl-exchanging-currency" />
    </template>
    <template #content>
      <bg-text type="body-sm">
        Pague para <bg-text
          is="strong"
          type="body-sm"
          weight="bold"
        >
          qualquer lugar do mundo
        </bg-text> com a mesma simplicidade que você já faz seus pagamentos locais. Além da facilidade
        de uso, também analisamos sua lista de pagamentos, realizando as
        transações de forma segura para todas as partes. Pagamos para qualquer
        lugar do mundo com a mesma eficiência e segurança de sempre.
      </bg-text>
      <div class="flex">
        <tr-button
          variant="raised"
          color="primary"
          label="Testar remessas internacionais"
          type="button"
          @click="experimentTrial"
        />
        <tr-button
          variant="raised"
          label="Saber mais"
          type="button"
          @click="experimentTrial"
        />
      </div>
    </template>
    <template #details>
      <bg-stack space="md">
        <bg-text type="h6">
          Câmbio justo e Transparente
        </bg-text>
        <bg-text type="body-sm">
          Verificamos as cotações cambiais e aprovamos com você a taxa a ser
          realizada para cada remessa. Além disso, calculamos de maneira
          transparente todas as taxas e valores totais envolvidos na remessa,
          sem surpresas ou custos ocultos.
        </bg-text>
      </bg-stack>
      <bg-stack space="md">
        <bg-text type="h6">
          Envio simplificado
        </bg-text>
        <bg-text type="body-sm">
          Nesse momento seremos seu <bg-text
            is="i"
            class="italic"
            type="body-sm"
            v-text="'&quot' + 'concierge' + '&quot'"
          />. Por troca de arquivos, receberemos sua lista de pagamentos,
          e assim que recebermos o recurso, processamos seus pagamentos,
          simples assim!
        </bg-text>
      </bg-stack>
    </template>
  </info-page>
  <know-more-page v-else />
</template>

<script>
var KnowMoreRoute = { name: 'ForeignExchangesKnowMorePage' };
var FakeDoorRoute = { name: 'ForeignExchangesFakeDoorPage' };

export default {
  beforeRouteEnter(to, from, next) {
    checkpointResource.exists(checkpoint.FOREIGN_EXCHANGES_TRIAL_CLICKED).then(({ exists }) => {
      if (exists && to.name !== KnowMoreRoute.name) {
        return next(KnowMoreRoute);
      }

      if (!exists && to.name !== FakeDoorRoute.name) {
        return next(FakeDoorRoute);
      }

      next();
    });
  }
};
</script>

<script setup>
import InfoPage from '@/commons/components/presentational/InfoPage.vue';
import KnowMorePage from '@/commons/components/presentational/KnowMorePage.vue';
import checkpoint from '@/commons/constants/checkpoint';
import checkpointResource from '@/commons/resources/checkpoint';
import { BgIllustration, BgText, BgStack } from '@transfeeradev/bridge';
import { useRouter } from 'vue-router';

const router = useRouter();
const emit = defineEmits(['loading']);

defineProps({
  firstAccess: {
    type: Boolean
  }
});

emit('loading', false);

const experimentTrial = async () => {
  await checkpointResource.create(checkpoint.FOREIGN_EXCHANGES_TRIAL_CLICKED);
  await goToKnowMore();
};

const goToKnowMore = () => {
  return router.push({ name: 'ForeignExchangesKnowMorePage' });
};
</script>

<style scoped>
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.italic {
  font-style: italic;
}
</style>
